import { F0Button } from '@factorialco/f0-react'
import { FinanceWorkspacePayrollLandingDocument } from 'generated/resources/graphql'

import { useLazyQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { useBannerNavigation } from 'modules/finance/components/FinancialWorkspace/components/LaunchBanner/useBannerNavigation'
import { UploadPayrollButton as PayrollSummaryImportButton } from 'modules/finance/components/FinancialWorkspace/components/UploadPayroll'
import { usePayrollSummaryImportButton } from 'modules/payroll_bundle/hooks/usePayrollSummaryImportButton'

export const UploadPayrollButton = ({
  source = 'payrolldatalandingpage',
  type = 'default',
}: {
  source?: string
  type?: 'default' | 'outline'
}) => {
  const [refetch] = useLazyQuery(FinanceWorkspacePayrollLandingDocument)
  const { canSeeButton: canSeePayrollButton, loading } = usePayrollSummaryImportButton()

  const { navigate } = useBannerNavigation({
    skipFetch: loading || canSeePayrollButton,
  })

  if (!canSeePayrollButton) {
    return (
      <F0Button
        onClick={navigate}
        variant="outline"
        label={i18n.t('finance.financial_workspace.payroll.landing.go_to_payroll')}
      />
    )
  }

  return (
    <PayrollSummaryImportButton
      source={source}
      onFinish={() => {
        refetch()
      }}
      type={type}
    />
  )
}
